import { createSelector } from 'reselect';
import { STATE_KEY } from './index';
import { RecipeState } from './reducer';
import { Recipe } from './model';
import Types from 'Types';

export const selectRecipes = (state: Types.RootState) => {
  return state[STATE_KEY].recipes
}
export const selectActiveRecipeId = (state: Types.RootState) => state[STATE_KEY].activeRecipe;

export const selectIsFetchingRecipes = (state: Types.RootState) => state[STATE_KEY].isFetchingRecipes;

export const selectGroceries = (state: Types.RootState) => state[STATE_KEY].groceries

export const selectRecipe = (id: string) => createSelector(
  selectRecipes,
  recipes => recipes.find((recipe: Recipe) => recipe.id === id)
);

export const selectActiveRecipe = createSelector(
  selectRecipes,
  selectActiveRecipeId,
  (recipes, activeId) => recipes.find((recipe: Recipe) => recipe.id === activeId)
);

